var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('br'),_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":_vm.loaderType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }